import React from 'react'
import * as Sentry from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import { getSentryFeature } from './useFeatures'

const {
  REACT_APP_NODE_ENV,
  REACT_APP_SENTRY_CLIENT,
  REACT_APP_SENTRY_ERROR_RATE,
  REACT_APP_SENTRY_TRACES_RATE,
} = process.env

const errorBlockList = [
  //eslint-disable-next-line
  "Can't find variable: gmo",
  'client: undefined - getActivesYears, usuário sem token.',
  'Esta conta está inativa.',
  'Failed to fetch',
  'GraphQL error: Authorization token',
  'gtag',
  'originalPrompt',
  'Invalid Access Token',
  'Java exception was raised during method invocation',
  'Load failed',
  'Login ou senha não encontrados',
  'n is not a function',
  'Network Error',
  'NetworkError',
  'Request failed with status code',
  'Response not successful: Received status code 403',
  'The operation was aborted. ',
]

let environment = REACT_APP_NODE_ENV
if (environment === 'pull_request') {
  environment = 'development'
}

const sentryAllowedEnvironments = ['production', 'staging']

const beforeSendFiltering = (FTErrorBlocklist: string[]) => (event: any, hint: any) => {
  if (hint?.originalException) {
    let message: string | undefined

    if (typeof hint.originalException === 'string') {
      message = hint.originalException
    } else if (typeof hint.originalException === 'object' && 'message' in hint.originalException) {
      message = (
        hint.originalException as {
          message: string
        }
      ).message
    }

    if (message) {
      const foundBlockListedTerm = !![...errorBlockList, ...FTErrorBlocklist].filter(
        (error: string) => message!.toLowerCase().includes(error.toLowerCase()),
      ).length

      if (foundBlockListedTerm) {
        return null
      }
    }
  }

  return event
}

const initSentry = async () => {
  if (!REACT_APP_SENTRY_CLIENT) {
    console.warn('Sentry client not found')
    return
  }

  if (!REACT_APP_SENTRY_ERROR_RATE) {
    console.warn('Sentry error rate not found')
    return
  }

  if (!REACT_APP_SENTRY_TRACES_RATE) {
    console.warn('Sentry traces rate not found')
    return
  }

  if (REACT_APP_SENTRY_CLIENT && environment && sentryAllowedEnvironments.includes(environment)) {
    const features = await getSentryFeature()

    Sentry.init({
      dsn: REACT_APP_SENTRY_CLIENT,
      environment,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV6Instrumentation(
            React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          ),
        }),
      ],
      denyUrls: [...features.denyUrls],

      sampleRate: +REACT_APP_SENTRY_ERROR_RATE,
      tracesSampleRate: +REACT_APP_SENTRY_TRACES_RATE,
      beforeSend: beforeSendFiltering(features.errorBlocklist),
      ignoreErrors: [...features.ignoreErrors],
    })
  }
}

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export { initSentry, SentryRoutes }
